import Vue from 'vue'

const client = () => Vue.prototype.$api

export default {
    sendWhoInData (data) {
        return client().post('forum/createWhoInEntry', data)
    },
    editWhoInEntry (data) {
        return client().put('forum/editWhoInEntry', data)
    },
    updateWhoInParticipant (data) {
        return client().put('forum/UpdateWhoInParticipant', data)
    },
    getActivities (forSearch, otherActivitiesGrouped) {
        return client().get('forum/activities', { params: { forSearch: forSearch, otherActivitiesGrouped: otherActivitiesGrouped } })
    },
    getActivitiesLevel () {
        return client().get('forum/activitiesLevel')
    },
    searchActivity (params) {
        return client().get('forum/searchActivity', { params: params })
    }
}


// WEBPACK FOOTER //
// ./src/repositories/ForumRepository.js